const statusMapping = {
  "-1": "Cancelled",
  0: "Pending",
  5: "En-route",
  10: "Delivered",
};

export default statusMapping;
